/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { VendorErrorCodeLinkedUnresolvedSummaryDto } from './VendorErrorCodeLinkedUnresolvedSummaryDto';
import {
    VendorErrorCodeLinkedUnresolvedSummaryDtoFromJSON,
    VendorErrorCodeLinkedUnresolvedSummaryDtoFromJSONTyped,
    VendorErrorCodeLinkedUnresolvedSummaryDtoToJSON,
    VendorErrorCodeLinkedUnresolvedSummaryDtoToJSONTyped,
} from './VendorErrorCodeLinkedUnresolvedSummaryDto';
import type { VendorErrorCategory } from './VendorErrorCategory';
import {
    VendorErrorCategoryFromJSON,
    VendorErrorCategoryFromJSONTyped,
    VendorErrorCategoryToJSON,
    VendorErrorCategoryToJSONTyped,
} from './VendorErrorCategory';
import type { VendorErrorCodeManufacturerSummaryDto } from './VendorErrorCodeManufacturerSummaryDto';
import {
    VendorErrorCodeManufacturerSummaryDtoFromJSON,
    VendorErrorCodeManufacturerSummaryDtoFromJSONTyped,
    VendorErrorCodeManufacturerSummaryDtoToJSON,
    VendorErrorCodeManufacturerSummaryDtoToJSONTyped,
} from './VendorErrorCodeManufacturerSummaryDto';
import type { VendorErrorParameter } from './VendorErrorParameter';
import {
    VendorErrorParameterFromJSON,
    VendorErrorParameterFromJSONTyped,
    VendorErrorParameterToJSON,
    VendorErrorParameterToJSONTyped,
} from './VendorErrorParameter';
import type { VendorErrorSource } from './VendorErrorSource';
import {
    VendorErrorSourceFromJSON,
    VendorErrorSourceFromJSONTyped,
    VendorErrorSourceToJSON,
    VendorErrorSourceToJSONTyped,
} from './VendorErrorSource';
import type { VendorErrorState } from './VendorErrorState';
import {
    VendorErrorStateFromJSON,
    VendorErrorStateFromJSONTyped,
    VendorErrorStateToJSON,
    VendorErrorStateToJSONTyped,
} from './VendorErrorState';
import type { VendorErrorCodeAssetTypeSummaryDto } from './VendorErrorCodeAssetTypeSummaryDto';
import {
    VendorErrorCodeAssetTypeSummaryDtoFromJSON,
    VendorErrorCodeAssetTypeSummaryDtoFromJSONTyped,
    VendorErrorCodeAssetTypeSummaryDtoToJSON,
    VendorErrorCodeAssetTypeSummaryDtoToJSONTyped,
} from './VendorErrorCodeAssetTypeSummaryDto';
import type { VendorErrorImpactedComponent } from './VendorErrorImpactedComponent';
import {
    VendorErrorImpactedComponentFromJSON,
    VendorErrorImpactedComponentFromJSONTyped,
    VendorErrorImpactedComponentToJSON,
    VendorErrorImpactedComponentToJSONTyped,
} from './VendorErrorImpactedComponent';
import type { VendorErrorSeverity } from './VendorErrorSeverity';
import {
    VendorErrorSeverityFromJSON,
    VendorErrorSeverityFromJSONTyped,
    VendorErrorSeverityToJSON,
    VendorErrorSeverityToJSONTyped,
} from './VendorErrorSeverity';

/**
 * 
 * @export
 * @interface VendorErrorCodeResponseDto
 */
export interface VendorErrorCodeResponseDto {
    /**
     * 
     * @type {string}
     * @memberof VendorErrorCodeResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof VendorErrorCodeResponseDto
     */
    manufacturerId: string;
    /**
     * 
     * @type {string}
     * @memberof VendorErrorCodeResponseDto
     */
    assetTypeId: string;
    /**
     * 
     * @type {string}
     * @memberof VendorErrorCodeResponseDto
     */
    errorCode: string;
    /**
     * 
     * @type {string}
     * @memberof VendorErrorCodeResponseDto
     */
    matchType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VendorErrorCodeResponseDto
     */
    matchKey?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VendorErrorCodeResponseDto
     */
    vendorErrorCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VendorErrorCodeResponseDto
     */
    info?: string | null;
    /**
     * 
     * @type {VendorErrorParameter}
     * @memberof VendorErrorCodeResponseDto
     */
    parameter?: VendorErrorParameter | null;
    /**
     * 
     * @type {VendorErrorState}
     * @memberof VendorErrorCodeResponseDto
     */
    state?: VendorErrorState | null;
    /**
     * 
     * @type {VendorErrorImpactedComponent}
     * @memberof VendorErrorCodeResponseDto
     */
    impactedComponent?: VendorErrorImpactedComponent | null;
    /**
     * 
     * @type {VendorErrorCategory}
     * @memberof VendorErrorCodeResponseDto
     */
    category?: VendorErrorCategory | null;
    /**
     * 
     * @type {VendorErrorSeverity}
     * @memberof VendorErrorCodeResponseDto
     */
    severity?: VendorErrorSeverity | null;
    /**
     * 
     * @type {string}
     * @memberof VendorErrorCodeResponseDto
     */
    firmwareVersion?: string | null;
    /**
     * Server-managed provenance; not writable via create/update
     * @type {VendorErrorSource}
     * @memberof VendorErrorCodeResponseDto
     */
    source: VendorErrorSource;
    /**
     * 
     * @type {string}
     * @memberof VendorErrorCodeResponseDto
     */
    description?: string | null;
    /**
     * 
     * @type {VendorErrorCodeManufacturerSummaryDto}
     * @memberof VendorErrorCodeResponseDto
     */
    manufacturer?: VendorErrorCodeManufacturerSummaryDto;
    /**
     * 
     * @type {VendorErrorCodeAssetTypeSummaryDto}
     * @memberof VendorErrorCodeResponseDto
     */
    assetType?: VendorErrorCodeAssetTypeSummaryDto;
    /**
     * Nullable summary of the linked unresolved record ({ id, version, status }) when one exists via resolvedFromUnresolved; null when there is no linked unresolved row. Present on catalog list and get responses
     * @type {VendorErrorCodeLinkedUnresolvedSummaryDto}
     * @memberof VendorErrorCodeResponseDto
     */
    linkedUnresolved?: VendorErrorCodeLinkedUnresolvedSummaryDto | null;
    /**
     * 
     * @type {Date}
     * @memberof VendorErrorCodeResponseDto
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof VendorErrorCodeResponseDto
     */
    updatedAt: Date;
}



/**
 * Check if a given object implements the VendorErrorCodeResponseDto interface.
 */
export function instanceOfVendorErrorCodeResponseDto(value: object): value is VendorErrorCodeResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('manufacturerId' in value) || value['manufacturerId'] === undefined) return false;
    if (!('assetTypeId' in value) || value['assetTypeId'] === undefined) return false;
    if (!('errorCode' in value) || value['errorCode'] === undefined) return false;
    if (!('source' in value) || value['source'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function VendorErrorCodeResponseDtoFromJSON(json: any): VendorErrorCodeResponseDto {
    return VendorErrorCodeResponseDtoFromJSONTyped(json, false);
}

export function VendorErrorCodeResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): VendorErrorCodeResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'manufacturerId': json['manufacturerId'],
        'assetTypeId': json['assetTypeId'],
        'errorCode': json['errorCode'],
        'matchType': json['matchType'] == null ? undefined : json['matchType'],
        'matchKey': json['matchKey'] == null ? undefined : json['matchKey'],
        'vendorErrorCode': json['vendorErrorCode'] == null ? undefined : json['vendorErrorCode'],
        'info': json['info'] == null ? undefined : json['info'],
        'parameter': json['parameter'] == null ? undefined : VendorErrorParameterFromJSON(json['parameter']),
        'state': json['state'] == null ? undefined : VendorErrorStateFromJSON(json['state']),
        'impactedComponent': json['impactedComponent'] == null ? undefined : VendorErrorImpactedComponentFromJSON(json['impactedComponent']),
        'category': json['category'] == null ? undefined : VendorErrorCategoryFromJSON(json['category']),
        'severity': json['severity'] == null ? undefined : VendorErrorSeverityFromJSON(json['severity']),
        'firmwareVersion': json['firmwareVersion'] == null ? undefined : json['firmwareVersion'],
        'source': VendorErrorSourceFromJSON(json['source']),
        'description': json['description'] == null ? undefined : json['description'],
        'manufacturer': json['manufacturer'] == null ? undefined : VendorErrorCodeManufacturerSummaryDtoFromJSON(json['manufacturer']),
        'assetType': json['assetType'] == null ? undefined : VendorErrorCodeAssetTypeSummaryDtoFromJSON(json['assetType']),
        'linkedUnresolved': json['linkedUnresolved'] == null ? undefined : VendorErrorCodeLinkedUnresolvedSummaryDtoFromJSON(json['linkedUnresolved']),
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

export function VendorErrorCodeResponseDtoToJSON(json: any): VendorErrorCodeResponseDto {
    return VendorErrorCodeResponseDtoToJSONTyped(json, false);
}

export function VendorErrorCodeResponseDtoToJSONTyped(value?: VendorErrorCodeResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'manufacturerId': value['manufacturerId'],
        'assetTypeId': value['assetTypeId'],
        'errorCode': value['errorCode'],
        'matchType': value['matchType'],
        'matchKey': value['matchKey'],
        'vendorErrorCode': value['vendorErrorCode'],
        'info': value['info'],
        'parameter': VendorErrorParameterToJSON(value['parameter']),
        'state': VendorErrorStateToJSON(value['state']),
        'impactedComponent': VendorErrorImpactedComponentToJSON(value['impactedComponent']),
        'category': VendorErrorCategoryToJSON(value['category']),
        'severity': VendorErrorSeverityToJSON(value['severity']),
        'firmwareVersion': value['firmwareVersion'],
        'source': VendorErrorSourceToJSON(value['source']),
        'description': value['description'],
        'manufacturer': VendorErrorCodeManufacturerSummaryDtoToJSON(value['manufacturer']),
        'assetType': VendorErrorCodeAssetTypeSummaryDtoToJSON(value['assetType']),
        'linkedUnresolved': VendorErrorCodeLinkedUnresolvedSummaryDtoToJSON(value['linkedUnresolved']),
        'createdAt': value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'].toISOString(),
    };
}

